<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" class="inline-form">
        <el-form-item label="订单号">
          <el-input v-model="searchInfo.orderId" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model="searchInfo.merchantId" clearable></el-input>
        </el-form-item>
        <el-form-item label="通道订单号">
          <el-input v-model="searchInfo.channelOrderId" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchInfo.orderState" placeholder="请选择">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchLoading"></auth-button>
          <auth-button opt="clear" :plain="true" @click.native="exportClick" label="清空" ></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 提取记录table -->
      <el-table
        style="width:100%;"
        stripe
        border
        v-loading="searchLoading"
        :data="packagelist"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column v-for="item in labelHeader" :key="item.key" :property="item.key" :label="item.label" align="center" >
            <template slot-scope="scope">
                {{scope.row[scope.column.property]}}
            </template>
        </el-table-column>
      </el-table>
      <div style="padding-top:20px">订单总金额：{{orderAmonut}}元</div>
      <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo" :size="paginations.pageSize"></pagination>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import pagination from '@/components/pagination'
import { listPackageOrderInfo } from '@/api/transaction'
export default {
  name: 'PackageOrderInfo',
  components: {
    pagination
  },
  data () {
    return {
      searchLoading: false,
      packagelist: '',
      orderAmonut: '',
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        merchantId: '',
        orderId: '',
        channelOrderId: '',
        orderState: 0
      },
      options: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '支付中'
      }, {
        value: 5,
        label: '支付成功'
      }, {
        value: 7,
        label: '支付失败'
      }, {
        value: 11,
        label: '取消订单成功'
      }],
      labelHeader: [{
        label: '订单号',
        key: 'orderId'
      }, {
        label: '商户编号',
        key: 'merchantId'
      }, {
        label: '通道订单号',
        key: 'channelOrderId'
      }, {
        label: '订单金额',
        key: 'amount'
      }, {
        label: '套餐名称',
        key: 'name'
      }, {
        label: '订单状态',
        key: 'orderStateStr'
      }, {
        label: '生效时间',
        key: 'effectTime'
      }, {
        label: '失效时间',
        key: 'expireTime'
      }, {
        label: '直属业务员',
        key: 'merchantKeeperId'
      }, {
        label: '直属代理商',
        key: 'agentId'
      }]
    }
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getPackageList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.getPackageList()
    },
    getPackageList () {
      this.searchLoading = true
      this.orderAmonut = ''
      const params = qs.stringify(Object.assign(this.searchInfo, this.paginations))
      listPackageOrderInfo(params).then(data => {
        this.searchLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          if (data.list) {
            this.packagelist = data.list
            this.paginations.count = data.totalCount
            this.packagelist.forEach(item => {
              item.amount = (item.amount / 100).toFixed(2)
            })
            if (data.totalAmount) {
              this.orderAmonut = (data.totalAmount / 100).toFixed(2)
            }
          }
        }
      })
    }
  },
  mounted () {
    this.getPackageList()
  }
}
</script>

<style lang="scss" scoped>
  @mixin flex-horizontal {
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.extract-amount {
  @include flex-horizontal;
  justify-content: center;
  margin: 30px 0;
  .extract-amount-input {
    margin-left: 15px;
    width: 300px;
    .extract-all {
      cursor: pointer;
    }
  }
}
</style>
